import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { VariablesEnum } from "../auth/enum/variables.enum";
import { LocalStorageService } from "../services/localstorage.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const session = this.localStorageService.getJsonValue(
      VariablesEnum.usuario_conade,
    );

    const esRutaAuth =
      state.url.includes("auth") || state.url.includes("signin");

    if (esRutaAuth) {
      if (session) {
        this.router.navigate(["components/home"]);
        return false;
      }
      return true;
    }

    if (session) {
      return true;
    }

    this.router.navigate(["auth/signin"]);
    return false;
  }
}
